import { useTranslation } from 'react-i18next';

import st from './SelectedEventEmptyState.module.sass';

export function SelectedEventEmptyState(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={st.NoSelectedEventDummy}>
      <div className={st.DummyText}>{t('lunapoint:панель оператора.выберите событие')}</div>
      <div className={st.DummyPicture} />
    </div>
  );
}
